
import { TranslationSet } from '../types';

export const notFound: TranslationSet = {
  'notFound.title': {
    en: 'Page Not Found',
    ja: 'ページが見つかりません',
    es: 'Página no encontrada',
    zh: '页面未找到',
    fa: 'Page Not Found'
  },
  'notFound.subtitle': {
    en: 'The page you are looking for doesn\'t exist or has been moved.',
    ja: 'お探しのページは存在しないか、移動されました。',
    es: 'La página que estás buscando no existe o ha sido movida.',
    zh: '您查找的页面不存在或已被移动。',
    fa: 'The page you are looking for doesn\'t exist or has been moved.'
  },
  'notFound.home': {
    en: 'Go to Home',
    ja: 'ホームに戻る',
    es: 'Ir a Inicio',
    zh: '返回首页',
    fa: 'Go to Home'
  },
  'notFound.back': {
    en: 'Go Back',
    ja: '戻る',
    es: 'Volver',
    zh: '返回',
    fa: 'Go Back'
  },
  'notFound.createEntry': {
    en: 'Create an Entry',
    ja: 'エントリーを作成',
    es: 'Crear una entrada',
    zh: '创建条目',
    fa: 'Create an Entry'
  }
};
